import { render } from "./System-Info.vue?vue&type=template&id=682b6388&scoped=true"
import script from "./System-Info.vue?vue&type=script&lang=js"
export * from "./System-Info.vue?vue&type=script&lang=js"

import "./System-Info.vue?vue&type=style&index=0&id=682b6388&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682b6388"]])

export default __exports__